import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled, { useTheme } from 'styled-components'

import { FlexColumn, FlexRow } from '@/@bothrs-ui/web/components/layout'
import { useNavigate } from '@/router-wrapper'
import { openUrl } from '@/utils/external-resources'

import type { MessageAttachment } from '../../types/message.types'

type Props = {
  attachment: MessageAttachment
  source?: 'message' | 'communication'
  onAttachmentOpen?: () => void
}

export function MessageAttachmentItem({ attachment, source, onAttachmentOpen }: Props) {
  const theme = useTheme()
  const navigate = useNavigate()

  // Interaction methods
  // ------------------------------------------------------------------------- /
  const handleClick = () => {
    onAttachmentOpen?.()

    if ('fileUrl' in attachment) {
      openUrl(attachment.fileUrl)
    }

    if ('fileId' in attachment) {
      const parameters = new URLSearchParams({
        fileName: attachment.name,
        ...(source && { source }),
      })
      navigate(`/documents/personal/preview/${attachment.fileId}?${parameters.toString()}`)
    }
  }

  return (
    <StyledAttachmentItem onClick={handleClick}>
      <FlexRow gap={theme.UI.Spacing.Space2} alignItems='center' style={{ flex: 1, minWidth: 0 }}>
        <StIcon icon={['fal', 'file']} style={{ width: 20, height: 20, flexShrink: 0 }} />
        <FlexColumn style={{ flex: 1, minWidth: 0 }} gap={theme.UI.Spacing.Space2}>
          <StDisplayText>{attachment.name}</StDisplayText>
          <StExtension>{attachment.extension?.replace(/^\./, '') || 'Bijlage'}</StExtension>
        </FlexColumn>
      </FlexRow>

      <StIcon icon={'fileId' in attachment ? ['far', 'chevron-right'] : ['fal', 'external-link']} />
    </StyledAttachmentItem>
  )
}

const StyledAttachmentItem = styled(FlexRow)`
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.Colors.Neutrals[50]};
  border-radius: ${({ theme }) => theme.UI.BorderRadius.Small}px;
  padding: ${({ theme }) => theme.UI.SpacingPx.Space4} 0;
  min-width: 0;

  cursor: pointer;
`
const StIcon = styled(FontAwesomeIcon)`
  padding: 0 ${({ theme }) => theme.UI.SpacingPx.Space4};
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
`

const StDisplayText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  color: ${({ theme }) => theme.Colors.Neutrals.Darkest};
`

const StExtension = styled.div`
  font-size: ${({ theme }) => theme.Typography.BodySmallRegular['font-size']};
  line-height: ${({ theme }) => theme.Typography.BodySmallRegular['line-height']};
  color: ${({ theme }) => theme.Colors.Neutrals[500]};
  text-transform: uppercase;
`
